export function set_enemy_as_token(enemy) {
  enemy.hp = 1
  enemy.damage = 1
}
